module.exports = __webpack_public_path__ + "static/lahli_bites_ingredients_HP-029e00a8d18a4a578b96677aa5d53c85.png";